// extracted by mini-css-extract-plugin
export default {"layout":"_9162fbdb36 _1526dca3a6 _6b8db8ac6b","h_slide":"ff4cc5fd54","category":"c527f1ce32 _56fefa0a7a f58ae97933"};